module.exports = __webpack_public_path__ + "static/media/faq-960.068df287.webp";